import styled from 'styled-components';
import { ReactComponent as Shield } from '../../assets/img/shield.svg';
import { fontDisplay } from '../../theme/typography';

export const StyledWinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90px;
  width: 90px;
  justify-content: space-between;
  img {
    max-width: 70px;
    max-height: 70px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const StyledLabel = styled.span`
  ${fontDisplay};
  font-size: 12px;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledSeparator = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.border};
  margin: 15px 0;
`;
export const StyledNoWinner = styled(Shield)`
  width: 70px;
  height: 70px;
  path {
    fill: ${({ theme }) => theme.border};
  }
`;
